























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ProposalsService } from "@/services/Proposals.service.ts";
import Number from "@/shared/filters/Number";
import { Proposal, ProposalItem } from "@/models/Coupon.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import DialogMasterCopy from "./components/DialogMasterCopy.vue";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
import ComponentWithGroupShaten from '@/views/components/ComponentWithGroupShaten';

export interface ProposalItemTb extends ProposalItem {
  isEdit?: boolean;
}

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable,
    DialogMasterCopy
  },
  mixins: [FilterSelectBox]
})
export default class ProposalDetail extends ComponentWithGroupShaten {
  @Prop({ default: "" })
  title: string;

  public groupDataList: any = [];
  public shatenDataList: any = [];
  public proposalService = new ProposalsService();
  public proposalData: ProposalItem;
  public proposalEdit: ProposalItem;
  public proposalList: ProposalItemTb[] = [];
  public proposalItemList: ProposalItemTb[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;


  public dialogFormVisible: boolean = false;
  maxProposal: number = 10;
  // disableBtnAdd: boolean = true;
  timerReOrder: any = null;
  public showProposal: boolean = false;
  public showFlg: any = {
    displayCoupon: 0,
    displayProposal: 0,
    displayTokuten: 0,
    displayAdditionalOptions: 0
  };

  $refs!: {
    dialogCopy: DialogMasterCopy;
  };

  public async getShowFlag() {
    const response = await this.proposalService.getShowFlag(this.form);
    if (response) {
      this.showFlg = response;
      this.$set(
        this,
        "showProposal",
        this.showFlg.displayProposal == 1 ? true : false
      );
    }
  }

  constructor() {
    super();

    this.proposalData = {
      kyotenCd: "",
      proposalNm: ""
    };

    this.proposalEdit = {
      kyotenCd: "",
      proposalNm: ""
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.proposalData.proposalNm) {
      this.loading = true;
      const data = {
        ...this.proposalData,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd
      };
      this.addProposalItem({ ...data });
    }
  }



  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenCd
    );
    this.getProposalList();
    this.delay(1000);
  }

  public async getProposalList(id?: number) {
    const response = await this.proposalService.getProposals(this.form, id);
    if (response) {
      // for (let i = 0; i < 4; i++) {
      //   response.push({
      //       id: 7 + i,
      //       kyotenCd: kyoten,
      //       proposalNm: "大事な自動車保険のご相談" + i
      //     });
      // }
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "proposalList", [...data]);
    } else {
      this.$set(this, "proposalList", []);
    }
    // this.checkDisabledAdd();
  }

  public async addProposalItem(data: ProposalItem) {
    const response = await this.proposalService.editProposal(data);
    if (response) {
      // console.log('addProposalItem', response);
      this.proposalData.proposalNm = '';
      this.getProposalList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public async delCouponItem(id: number) {
    this.loading = true;
    const response = await this.proposalService.deleteProposal(id);
    if (response === 200) {
      this.getProposalList();
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.proposalEdit = { ...rowData };
  }

  public editProposalItem() {
    this.loading = true;
    if (this.proposalEdit.id && this.proposalEdit.proposalNm) {
      const data = {
        id: this.proposalEdit.id,
        groupCd: this.form.groupCd,
        shatenCd: this.form.shatenCd,
        kyotenCd: this.form.kyotenCd,
        proposalNm: this.proposalEdit.proposalNm
      };
      this.addProposalItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    this.getGroupDataList().then(res => {
      this.getShatenDataList().then(res2 => {
        this.getKyotenDataList().then(res3 => {
          this.getShowFlag();
          this.getProposalList();
        });
      });
    });
    this.form.kyotenCd = localStorage.getItem("kyotenCd");
  }

  get checkDisabledAdd() {
    let disabled = false;
    if (this.proposalList.length >= this.maxProposal) {
      disabled = true;
    } else if (this.proposalData.proposalNm === "") {
      disabled = true;
    }

    // this.$set(this, "disableBtnAdd", disabled);
    return disabled;
  }

  onEnd(event: any) {
    if (this.form.groupCd && this.form.shatenCd) {
      if (this.timerReOrder) {
        clearTimeout(this.timerReOrder);
        this.timerReOrder = null;
      }
      this.timerReOrder = setTimeout(() => {
        const data = this.proposalList.map((e: any) => {
          let item = {
            ...e,
            groupCd: this.form.groupCd,
            shatenCd: this.form.shatenCd
          };
          delete item.isEdit;
          return item;
        });
        this.saveProposalList(data);
      }, 1000);
    }
  }

  public async saveProposalList(data: any) {
    const response = await this.proposalService.saveProposals(data, this.form);
    if (response) {
      console.log(response);
    }
  }

  onOpenMasterCopy() {
    this.$refs.dialogCopy.open();
  }

  public async saveShowProposal() {
    const response = await this.proposalService.saveShowProposal({
      ...this.showFlg,
      displayProposal: this.showProposal ? 1 : 0,
      kyotenCd: this.form.kyotenCd
    });
    if (response) {
      console.log(response);
    }
  }
}
